import { addLocaleData } from 'react-intl';

import enLang from './entries/en-US';
import esLang from './entries/es_ES';

const AppLocale = {
  es: esLang,
  'en-us': enLang,
};
addLocaleData(AppLocale['en-us'].data);
addLocaleData(AppLocale.es.data);

export default AppLocale;
